import * as React from "react"
import { Grid } from "@mui/material"
import {string, object, array} from "yup";
import { DrawerSeeker, TextFieldSeeker, SelectSeeker, TagFieldSeeker } from "@ui-seeker/core"
import { useAppToast, useValidatorSeeker } from "@ui-seeker/app"
import { isEmpty } from '@ui-seeker/utils'

import { clickAndCollect } from "@signals"
import { stockAssDetailsReportFormIsOpen } from "../@signals"
import { useStockAssDetailsReportForm } from "../@hooks";
import { OPTIONS_FREQUENCY, STOCK_STATUS, OPTIONS_STREET_DATE } from "./constants"


export default function StockAssDetailsReportFormDrawer() {
	const { showToast } = useAppToast()
	const stockStatusOptions = clickAndCollect.value
		? STOCK_STATUS
		: STOCK_STATUS.filter(opt => opt.value !== 'click-and-collect')
	const {
		handleSendToBack, nameReport, frequency, emailsReport, conditions, resetFormData, streetDateFilter,
	} = useStockAssDetailsReportForm()

	const validatorData = useValidatorSeeker({
        nameReport: nameReport.value,
		frequency: frequency.value,
        emailsReport: emailsReport.value,
    }, object({
        nameReport: string().required('Report name must be provided'),
		frequency: string().required('Frequency must be provided'),
        emailsReport: array().min(1, 'At least 1 email is required'),
    }))

	if (!stockAssDetailsReportFormIsOpen.value) return <></>
	
    return <DrawerSeeker
		isOpen={stockAssDetailsReportFormIsOpen.value}
		controller={() => {
			stockAssDetailsReportFormIsOpen.value = false
			resetFormData()
		}}
		title={`Create New Stock & Affinity Details Report`}
		width="40%"
		successProps={{ onClick: isEmpty(validatorData.errors)
			? handleSendToBack
			: () => showToast.warning('Please ensure all mandatory fields are completed ') 
		}}
	>
    	<Grid container spacing={3}>
			<Grid item xs={12}>
				<TextFieldSeeker
					error={validatorData.errors?.nameReport}
					label="Report Name"
					size="small"
					fullWidth
					value={nameReport.value}
					onChange={e => nameReport.value = e.target.value}
					icon="pen-to-square"
				/>
			</Grid>

			<Grid item xs={12}>
				<SelectSeeker
					error={validatorData.errors?.frequency}
					label="Frequency"
					fullWidth
					options={OPTIONS_FREQUENCY}
					value={frequency.value}
					onChange={e => frequency.value = e.target.value}
				/>
			</Grid>

			<Grid item xs={12}>
				<SelectSeeker
					error={validatorData.errors?.conditions}
					label="Select to Filter Stock Status in Results"
					fullWidth
					multiple={true}
					isClearable={true}
					options={stockStatusOptions}
					value={conditions.value}
					onChange={e => conditions.value = e.target.value}
				/>
			</Grid>

			<Grid item xs={12}>
				<SelectSeeker
					label="Filter by Street Date (Leave Empty to select All)"
					fullWidth
					options={OPTIONS_STREET_DATE}
					value={streetDateFilter.value}
					onChange={e => streetDateFilter.value = e.target.value}
					isClearable
				/>
			</Grid>

			<Grid item xs={12}>
				<TagFieldSeeker
					error={validatorData.errors?.emailsReport}
					value={emailsReport.value}
					fullWidth
					onChange={e => emailsReport.value = e }
					label="Emails"
					placeholder="Enter to add emails"
				/>
			</Grid>

		</Grid>
    </DrawerSeeker>
}
